// 咨询服务
export const consultDetail = `/api/unoauth/AdviceTrain/getInfoByAdviceTrainType/`;
